import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/ui/checkbox'
import type { Proposal } from '@/services/api/structuredIngest'
import { textExtractionColumns, withTextExtraction } from './text-extraction'

export function TextExtractionOptions({
  recipe,
  disabled,
  onChange,
}: {
  recipe: Proposal
  disabled: boolean
  onChange: (recipe: Proposal) => void
}) {
  const { t } = useTranslation()
  const columns = textExtractionColumns(recipe)
  if (columns.length === 0) return null
  return (
    <fieldset disabled={disabled} className="rounded-md border bg-muted/30 p-3">
      <legend className="px-1 text-sm font-medium">{t('tableMapping.extraction.title')}</legend>
      <p className="mb-3 text-xs text-muted-foreground">
        {t('tableMapping.extraction.description')}
      </p>
      <div className="flex flex-col gap-2">
        {columns.map(column => (
          <label
            key={`${column.entity}:${column.name}`}
            className="flex items-center gap-2 text-xs"
          >
            <Checkbox
              checked={column.extract_entities === true}
              disabled={disabled}
              onCheckedChange={checked =>
                onChange(withTextExtraction(recipe, column, checked === true))
              }
            />
            <span className="font-mono">{column.name}</span>
            <span className="text-muted-foreground">
              {column.entity}.{column.property || column.alias}
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  )
}
